import React, { useEffect, useState } from "react";
import "./HomeCarousel.css";
import video6 from "../../../assets/sliderImages/video6.mp4";
import carouselImage from "../../../assets/images/siemens.png";

const textSlides = [
  {
    text: "We expertise in Teamcenter PLM, Polarion ALM, Opcenter MES, Mendix Apps & SaaS Solutions",
  },
  {
    text: "Enhance Profitability and Efficiency by Speeding Up Digital Transformation",
  },
  {
    text: "Expand the PLM Ecosystem Across the Extended Enterprise",
  }
];

const HomeCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [animateSlide, setAnimateSlide] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimateSlide(true); // Trigger animation for slide transition
      setTimeout(() => {
        setCurrentSlide((prev) => (prev === textSlides.length - 1 ? 0 : prev + 1));
        setAnimateSlide(false); // Reset animation state
      }, 2000); // Slide visible for 4 seconds
    }, 4000); // Cycle through every 6 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <div className="carousel-video">
            <video src={video6} autoPlay loop muted className="d-block w-100"></video>
            <div className="caption-image">
              <img src={carouselImage} alt="Carousel" />
            </div>
            <div className="carousel-caption">
              <div className={`caption-text ${animateSlide ? "animate" : ""}`}>
                <p>{textSlides[currentSlide].text}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeCarousel;
